import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import { tokens } from "../../theme/galleryTheme";


export default function ArtworkFrame({
  src,
  alt = "",
  ratio = "4 / 5",
  fit = "contain",
  position = "center",
  mat = tokens.color.ivory,
  padding = { xs: 1.5, md: 2 },
  eager = false,
  sx,
  children,
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const showImage = Boolean(src) && !failed;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: ratio,
        overflow: "hidden",
        bgcolor: mat,
        ...sx,
      }}
    >
      {showImage ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            p: fit === "contain" ? padding : 0,
            display: "flex",
          }}
        >
          <Box
            component="img"
            className="lg-frame-img"
            src={src}
            alt={alt}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            draggable={false}
            onError={() => setFailed(true)}
            sx={{
              display: "block",
              width: "100%",
              height: "100%",
              objectFit: fit,
              objectPosition: position,
              transition: "transform 0.5s ease",
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Typography variant="caption" component="span">
            Image not available
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}
